import React, { useEffect } from 'react'
import { PageLayout } from '@/common/layouts/PageLayout.tsx'
import { useDispatch } from 'react-redux'
import { logout } from '@/features/auth/auth.slice.ts'
import { Button } from 'antd'
import { Link } from 'react-router'
import { PageTitle } from '@/common/components/PageTitle.tsx'

export const LogoutPage: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(logout())
  }, [dispatch])

  return (
    <PageLayout className="h-full flex flex-col items-center justify-center">
      <PageTitle value="Logout" />
      <h1 className="text-3xl font-bold mb-4">Logout Successfully</h1>
      <Link to="/login"><Button>Login</Button></Link>
    </PageLayout>
  )
}